import { useState } from "react";

export const useGalleryData = () => {
  const [selectedCategory, setSelectedCategory] = useState("all");
  const [projects, setProjects] = useState([
    // Hero/Featured Projects
    {
      id: 1,
      src: `${process.env.PUBLIC_URL}/images/kitchen.jpg`,
      title: "Full Renovations",
      category: "kitchen",
      height: "tall",
    },
    {
      id: 2,
      src: `${process.env.PUBLIC_URL}/images/bathroom2.jpg`,
      title: "Luxury Bathroom Renovation",
      category: "bathroom",
      height: "medium",
    },
    {
      id: 3,
      src: `${process.env.PUBLIC_URL}/images/fireplace1.jpg`,
      title: "Modern Look",
      category: "fireplace",
      height: "tall",
    },
    // Gallery Projects with varied heights
    {
      id: 4,
      src: `${process.env.PUBLIC_URL}/images/gal1.jpg`,
      title: "Elegant & Seamless",
      category: "kitchen",
      height: "short",
    },
    {
      id: 5,
      src: `${process.env.PUBLIC_URL}/images/gal2.jpg`,
      title: "Contemporary Design",
      category: "kitchen",
      height: "medium",
    },
    {
      id: 6,
      src: `${process.env.PUBLIC_URL}/images/gal3.jpg`,
      title: "Custom Installation",
      category: "kitchen",
      height: "short",
    },
    {
      id: 7,
      src: `${process.env.PUBLIC_URL}/images/gal4.jpg`,
      title: "Geometric Patterns",
      category: "bathroom",
      height: "tall",
    },
    {
      id: 8,
      src: `${process.env.PUBLIC_URL}/images/gal5.jpg`,
      title: "Natural Looks",
      category: "bathroom",
      height: "medium",
    },
    {
      id: 9,
      src: `${process.env.PUBLIC_URL}/images/gal6.jpg`,
      title: "Modern Aesthetics",
      category: "bathroom",
      height: "short",
    },
    {
      id: 10,
      src: `${process.env.PUBLIC_URL}/images/gal7.jpg`,
      title: "Professional Finish",
      category: "bathroom",
      height: "medium",
    },
    {
      id: 11,
      src: `${process.env.PUBLIC_URL}/images/gal8.jpg`,
      title: "Detailed Craftsmanship",
      category: "bathroom",
      height: "tall",
    },
    {
      id: 12,
      src: `${process.env.PUBLIC_URL}/images/gal9.jpg`,
      title: "Precise Craftsmanship",
      category: "bathroom",
      height: "short",
    },
    {
      id: 13,
      src: `${process.env.PUBLIC_URL}/images/gal10.jpg`,
      title: "Beautiful Stonework",
      category: "fireplace",
      height: "medium",
    },
    {
      id: 14,
      src: `${process.env.PUBLIC_URL}/images/gal11.jpg`,
      title: "Expert Installation",
      category: "fireplace",
      height: "short",
    },
    {
      id: 15,
      src: `${process.env.PUBLIC_URL}/images/gal12.jpg`,
      title: "Stunning Results",
      category: "fireplace",
      height: "tall",
    },
    {
      id: 16,
      src: `${process.env.PUBLIC_URL}/images/flooring.jpg`,
      title: "Beautiful Flooring",
      category: "flooring",
      height: "medium",
    },
    {
      id: 17,
      src: `${process.env.PUBLIC_URL}/images/niche_showcase.png`,
      title: "Custom niche & mosaic",
      category: "bathroom",
      height: "medium",
    },
    {
      id: 18,
      src: `${process.env.PUBLIC_URL}/images/backsplash.jpg`,
      title: "Artistic Backsplash",
      category: "kitchen",
      height: "short",
    },
    {
      id: 19,
      src: `${process.env.PUBLIC_URL}/images/full_reno_1.png`,
      title: "Open-concept renovation",
      category: "kitchen",
      height: "tall",
    },
    {
      id: 20,
      src: `${process.env.PUBLIC_URL}/images/outdoor_1.png`,
      title: "Ledger stone & exterior masonry",
      category: "flooring",
      height: "medium",
    },
    {
      id: 21,
      src: `${process.env.PUBLIC_URL}/images/fireplace_beautiful.png`,
      title: "Custom stone fireplace",
      category: "fireplace",
      height: "tall",
    },
    {
      id: 22,
      src: `${process.env.PUBLIC_URL}/images/niche.jpg`,
      title: "Inset shower niche",
      category: "bathroom",
      height: "medium",
    },
    {
      id: 24,
      src: `${process.env.PUBLIC_URL}/images/mud2.jpg`,
      title: "Mud pan & slope work",
      category: "bathroom",
      height: "short",
    },
    {
      id: 26,
      src: `${process.env.PUBLIC_URL}/images/fireoven.jpg`,
      title: "Fireplace & hearth detail",
      category: "fireplace",
      height: "medium",
    },
    {
      id: 27,
      src: `${process.env.PUBLIC_URL}/images/wall.jpg`,
      title: "Feature wall installation",
      category: "kitchen",
      height: "medium",
    },
    {
      id: 28,
      src: `${process.env.PUBLIC_URL}/images/bathroom_10.png`,
      title: "Bathroom 10 — marble subway & octagon floor",
      category: "bathroom",
      height: "tall",
    },
    {
      id: 29,
      src: `${process.env.PUBLIC_URL}/images/kitchen_14.png`,
      title: "Kitchen 14 — white cabinetry & subway backsplash",
      category: "kitchen",
      height: "medium",
    },
    {
      id: 30,
      src: `${process.env.PUBLIC_URL}/images/backsplash_herringbone.png`,
      title: "Backsplash — herringbone distressed tile",
      category: "kitchen",
      height: "short",
    },
    {
      id: 31,
      src: `${process.env.PUBLIC_URL}/images/floor_10.png`,
      title: "Floor 10 — high-contrast wood-look planks",
      category: "flooring",
      height: "tall",
    },
    {
      id: 32,
      src: `${process.env.PUBLIC_URL}/images/mud_job.png`,
      title: "Mud job — slab prep & leveling",
      category: "flooring",
      height: "medium",
    },
    {
      id: 33,
      src: `${process.env.PUBLIC_URL}/images/floor_11.png`,
      title: "Floor 11 — wood-look tile installation",
      category: "flooring",
      height: "medium",
    },
    {
      id: 34,
      src: `${process.env.PUBLIC_URL}/images/full_bath_16.png`,
      title: "Full bath 16 — stone walk-in shower",
      category: "bathroom",
      height: "tall",
    },
    {
      id: 35,
      src: `${process.env.PUBLIC_URL}/images/full_bath_15.png`,
      title: "Full bath 15 — floating vanity & charcoal tile",
      category: "bathroom",
      height: "medium",
    },
    {
      id: 36,
      src: `${process.env.PUBLIC_URL}/images/full_reno_pizza_place.png`,
      title: "Full reno — pizza place dining tile & flooring",
      category: "kitchen",
      height: "tall",
    },
    {
      id: 37,
      src: `${process.env.PUBLIC_URL}/images/backsplash_12.png`,
      title: "Backsplash 12 — mixed-tone subway behind range",
      category: "kitchen",
      height: "short",
    },
    {
      id: 38,
      src: `${process.env.PUBLIC_URL}/images/outdoor_3.png`,
      title: "Outdoor 3 — patio tile & hardscape",
      category: "flooring",
      height: "medium",
    },
    {
      id: 39,
      src: `${process.env.PUBLIC_URL}/images/full_reno_3.png`,
      title: "Full reno 3 — interior during renovation",
      category: "kitchen",
      height: "tall",
    },
  ]);

  const categories = [
    { id: "all", name: "All Work" },
    { id: "kitchen", name: "Kitchens" },
    { id: "bathroom", name: "Bathrooms" },
    { id: "fireplace", name: "Fireplaces" },
    { id: "flooring", name: "Flooring" },
  ];

  const filteredProjects =
    selectedCategory === "all"
      ? projects
      : projects.filter((project) => project.category === selectedCategory);

  return {
    projects,
    setProjects,
    selectedCategory,
    setSelectedCategory,
    categories,
    filteredProjects,
  };
};
